<template>
  <div class="relative flex flex-col min-w-0 break-words mt-4 mb-6 mx-4 lg:mx-8 shadow-lg rounded-lg bg-gray-200 border-0">
    <!--  -->
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-gray-800 text-xl font-bold">{{ $t('settings') }}</h6>
        <button @click="save"
          class="rouanded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"
          type="button">{{ $t('Save settings') }}</button>
      </div>
    </div>
    <!--  -->

    <!--  -->
    <div v-if="currentUser.type && currentUser.type != 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <!--  -->
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <!--  -->

      <!-- Admin tab bar -->
      <div class="flex flex-wrap border-b border-gray-300 mb-6">
        <button v-for="tab in adminTabs" :key="tab.key" @click="activeTab = tab.key" type="button"
          class="px-4 py-3 -mb-px text-sm font-bold uppercase focus:outline-none transition-all duration-150"
          :class="activeTab === tab.key ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'">
          {{ tab.label }}
        </button>
      </div>
      <!-- /Admin tab bar -->

      <!-- TAB: Telephony — per-warehouse gateways / call mode / PBX diagnostics.
           v-if so the child only mounts (and fetches) when the tab is opened. -->
      <div v-if="activeTab === 'telephony'">
        <TelephonySettings ref="telephonySettings" :warehouse="idWharhouse" />
      </div>
      <!-- /TAB: Telephony -->

      <!-- TAB: Fees -->
      <div v-show="activeTab === 'fees'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('order_fees') }}</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password">{{ $t('confirmation_fees') }} <sup
                v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.order.feesConfirmation" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="fulfillement_fees">{{ $t('fulfillement_fees') }} <sup
                v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.order.fulfillement_fees" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="fulfillement_fees">{{ $t('upsell fees')}} <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.order.upsell" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400">
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('shipping_fees') }}</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t('shipping_fees') }} 
              <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
            </label>
            <!--  -->

            <!--  -->
            <input v-if="coutryW != 'MA'" type="number" v-model="formData.detail.shipping.fees" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            <!--  -->

            <!--  -->
            <div v-else class="bg-white shadow-md rounded-lg px-3 py-2 mb-4 overflow-y-auto max-height-300">
              <div v-for="(zon, index) in cities" :key="index"
                class="flex justify-center items-center border-dotted border-4 border-light-blue-500 justify-start cursor-pointer text-gray-700 hover:text-blue-400 hover:bg-blue-100 rounded-md px-2 py-2 my-2">

                <div class="flex-grow w-4/5 font-medium px-2">
                  <span v-for="(city, ind) in zon._id.cities" :key="ind"
                    class="m-1 whitespace-nowrap bg-gray-200 hover:bg-gray-300 rounded-full px-2 font-bold text-sm leading-loose cursor-pointer">{{ city }}</span>
                </div>
                <div
                  class="py-1 w-1/5 h-8 flex justify-center items-center px-2 rounded-full text-xs bg-green-500 text-white cursor-pointer font-medium">
                  {{ zon._id.price }}</div>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password">{{ $t('return_fees') }} <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.shipping.refund" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password">{{ $t('cancelation_fees') }} <sup
                v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.shipping.cancelation" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->
      </div>
      <!--  -->

      </div>
      <!-- /TAB: Fees -->

      <!-- TAB: Quality & Conversion -->
      <div v-show="activeTab === 'quality'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('quality_control') }}</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password">{{ $t('quality_control') }} <sup
                v-if="idWharhouse">({{ idWharhouse.currency }})</sup></label>
            <input type="number" v-model="formData.detail.quality_control" min="0"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400">
      <!--  -->

      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">conversion</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-1/2 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">conversion orders</label>
            <!--  -->
            <div class="flex">
              <!--  -->
              <div class="w-1/2 border hover:border-green-500 focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                <!--  -->
                <div class="flex -mr-px justify-center p-1 rounded shadow ">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase"> MAD </sup><span class="select-none ml-2">
                      <img src="https://static.dwcdn.net/css/flag-icons/flags/4x3/ma.svg" class="flag-img">
                    </span>
                  </span>
                </div>
                <!--  -->
                <input type="number" v-model="formData.detail.info.mad" disabled min="1" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded text-sm shadow rounded-l-none px-3 self-center relative outline-none">
                <!--  -->
              </div>
              <!--  -->
              <i class="material-icons mx-2 items-center flex-imp">arrow_forward</i>
              <!--  -->
              <div class="w-1/2 border hover:border-green-500 focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1 rounded  shadow ">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase" v-if="idWharhouse"> {{ idWharhouse.currency }} </sup><span class="select-none ml-2"><img :src="idWharhouse ? idWharhouse.flag : ''" class="flag-img"></span>
                  </span>
                </div>
                <input type="number" v-model="formData.detail.info.currency" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded text-sm shadow rounded-l-none px-3 self-center relative outline-none">
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
        <div class="w-full lg:w-1/2 px-4">
          <!--  -->
          <div class="relative w-full mb-3">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">conversion crédits</label>
            <!--  -->
            <div class="flex">
              <!--  -->
              <div class="w-1/2 border hover:border-green-500 focus-within:border-blue-500 flex flex-wrap items-stretch relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1 rounded shadow ">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase"> MAD </sup><span class="select-none ml-2">
                      <img src="https://static.dwcdn.net/css/flag-icons/flags/4x3/ma.svg" class="flag-img">
                    </span>
                  </span>
                </div>
                <input type="number" v-model="formData.detail.info.mad" disabled min="1"
                  class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded text-sm shadow rounded-l-none px-3 self-center relative outline-none">
              </div>
              <!--  -->

              <!--  -->
              <i class="material-icons mx-2 items-center flex-imp">arrow_forward</i>
              <!--  -->

              <!--  -->
              <div class="w-1/2 border hover:border-green-500 focus-within:border-blue-500 flex flex-wrap items-stretch  relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1 rounded  shadow ">
                  <span
                    class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                    <sup class="uppercase" v-if="idWharhouse"> {{ idWharhouse.currency }} </sup><span
                      class="select-none ml-2"><img :src="idWharhouse ? idWharhouse.flag : ''" class="flag-img"></span>
                  </span>
                </div>
                <input type="number" v-model="formData.detail.info.currencyCredit" min="0" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded text-sm shadow rounded-l-none px-3 self-center relative outline-none">
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      </div>
      <!-- /TAB: Quality & Conversion -->

      <!-- TAB: AI Call-Center Agent -->
      <div v-show="activeTab === 'callcenterAi'" v-if="formData.detail.aiCallCenter" class="ai-tab">

        <!-- HERO -->
        <div class="ai-hero">
          <div class="ai-hero-icon">🤖</div>
          <div class="ai-hero-text">
            <h3>AI Call-Center Agent</h3>
            <p>The AI confirms qualifying orders in this warehouse instead of a human call-center — billed
              <b>${{ formData.detail.aiCallCenter.pricePerProcessed }}</b> per order that reaches Processed.
              Defaults to OFF + Shadow; nothing changes until you activate it.</p>
          </div>
        </div>

        <!-- WAREHOUSE CONTEXT — this config is PER WAREHOUSE -->
        <div class="ai-wh-banner">
          <div class="ai-wh-left">
            <img v-if="whFlag" :src="whFlag" class="ai-wh-flag" />
            <span v-else class="ai-wh-flag-fallback">🏬</span>
            <div>
              <div class="ai-wh-label">Configuring warehouse</div>
              <div class="ai-wh-name">{{ whName }}
                <span v-if="idWharhouse && idWharhouse.currency" class="ai-wh-cur">{{ idWharhouse.currency }}</span>
              </div>
            </div>
          </div>
          <div class="ai-wh-hint">↑ Switch warehouse in the top bar to configure another. Each warehouse is independent.</div>
        </div>

        <!-- ACTIVATION CARD -->
        <div class="ai-card ai-activate" :class="{ on: formData.detail.aiCallCenter.active }">
          <div class="ai-activate-left">
            <div class="ai-status-dot" :class="{ on: formData.detail.aiCallCenter.active }"></div>
            <div>
              <div class="ai-activate-title">{{ formData.detail.aiCallCenter.active ? 'Agent is active' : 'Agent is off' }}</div>
              <div class="ai-activate-sub">{{ formData.detail.aiCallCenter.active ? 'The AI is handling orders per the rules below.' : 'Turn on to configure how the AI confirms orders.' }}</div>
            </div>
          </div>
          <ai-switch size="lg" v-model="formData.detail.aiCallCenter.active" />
        </div>

        <!-- SETTINGS GRID -->
        <transition name="ai-fade">
        <div v-if="formData.detail.aiCallCenter.active" class="ai-grid">

          <!-- MODE -->
          <div class="ai-card">
            <div class="ai-card-head">
              <span class="ai-card-label">Mode</span>
              <span class="ai-pill" :class="formData.detail.aiCallCenter.mode === 'live' ? 'pill-live' : 'pill-shadow'">
                {{ formData.detail.aiCallCenter.mode === 'live' ? 'LIVE' : 'SHADOW' }}
              </span>
            </div>
            <ai-segmented v-model="formData.detail.aiCallCenter.mode" :options="[
              { value: 'shadow', label: 'Shadow', hint: 'watch only · free' },
              { value: 'live', label: 'Live', hint: 'auto-confirm · billed', danger: true },
            ]" />
            <p v-if="formData.detail.aiCallCenter.mode === 'live'" class="ai-warn">
              ⚠️ The AI will actually confirm orders (no human call). You'll be billed per processed order.
            </p>
            <p v-else class="ai-hint">Safe to leave on — it only logs what it would do.</p>
          </div>

          <!-- PRICE (fixed platform rate — not editable) -->
          <div class="ai-card">
            <div class="ai-card-head">
              <span class="ai-card-label">Price per processed order</span>
              <span class="ai-pill pill-neutral">FIXED</span>
            </div>
            <div class="ai-price is-disabled">
              <span class="ai-price-cur">$</span>
              <input type="number" step="0.01" min="0" disabled v-model.number="formData.detail.aiCallCenter.pricePerProcessed" />
              <span class="ai-price-unit">USD</span>
            </div>
            <p class="ai-hint">Charged only when an AI-confirmed order reaches Processed (cash collected).</p>
          </div>

          <!-- THRESHOLD -->
          <div class="ai-card">
            <div class="ai-card-head">
              <span class="ai-card-label">Confidence threshold</span>
              <span class="ai-pill pill-neutral">{{ Math.round(formData.detail.aiCallCenter.threshold * 100) }}%</span>
            </div>
            <ai-slider v-model="formData.detail.aiCallCenter.threshold" :min="0.70" :max="0.95" :step="0.01"
              min-label="70% · more automation" max-label="95% · safest"
              :format="v => Math.round(v * 100) + '%'" />
            <p class="ai-hint">Higher = safer (fewer, more certain confirms). 85% recommended.</p>
          </div>

          <!-- SCOPE -->
          <div class="ai-card">
            <div class="ai-card-head"><span class="ai-card-label">Scope</span></div>
            <ai-segmented v-model="formData.detail.aiCallCenter.scope" :options="[
              { value: 'all', label: 'All orders', hint: 'everything in this warehouse' },
              { value: 'sellers', label: 'Specific sellers', hint: 'pick which stores' },
            ]" />
            <!-- One list, one rule. Two separate lists let the same store be both
                 allowed and blocked, which is a contradiction the UI should not
                 allow — so pick the stores, then say what to do with them. -->
            <div v-if="formData.detail.aiCallCenter.scope === 'sellers'" class="ai-sellers">
              <div class="ai-sellers-head">
                <span class="ai-sellers-title">Which stores</span>
                <span class="ai-sellers-count" v-if="aiScopeSellers.length">
                  {{ aiScopeSellers.length }} selected
                </span>
              </div>
              <ai-segmented v-model="formData.detail.aiCallCenter.sellerMode" :options="[
                { value: 'only', label: 'Only these', hint: 'AI runs for these stores' },
                { value: 'except', label: 'All except these', hint: 'AI skips these stores' },
              ]" />
              <v-select class="ai-seller-select" placeholder="Search &amp; pick stores…"
                v-model="aiScopeSellers" multiple
                :options="aiSellers" label="fullName" :reduce="s => s._id">
                <template #option="o">
                  <div class="ai-opt">
                    <span class="ai-opt-avatar" :class="{ blocked: formData.detail.aiCallCenter.sellerMode === 'except' }">
                      {{ (o.fullName || '?').charAt(0).toUpperCase() }}
                    </span>
                    <span class="ai-opt-col">
                      <span class="ai-opt-name">{{ o.fullName }}</span>
                      <!-- some stores share a name, so show the email to tell them apart -->
                      <span class="ai-opt-mail" v-if="o.email">{{ o.email }}</span>
                    </span>
                  </div>
                </template>
                <template #no-options>No stores found for this warehouse.</template>
              </v-select>
              <p class="ai-hint" v-if="formData.detail.aiCallCenter.sellerMode === 'except'">
                The AI confirms orders from <b>every store except</b> the ones listed —
                their orders always go to a human. Leave empty = the AI runs for everyone.
              </p>
              <p class="ai-hint" v-else>
                The AI <b>only</b> confirms orders from the listed stores. Leave empty = none.
              </p>
            </div>
          </div>

          <!-- REQUIRE ADDRESS -->
          <div class="ai-card">
            <div class="ai-card-head">
              <span class="ai-card-label">Delivery address</span>
              <span class="ai-pill" :class="formData.detail.aiCallCenter.requireAddress ? 'pill-live' : 'pill-neutral'">
                {{ formData.detail.aiCallCenter.requireAddress ? 'REQUIRED' : 'NOT REQUIRED' }}
              </span>
            </div>
            <div class="ai-req-row">
              <div class="ai-req-text">
                <div class="ai-req-title">Require a real delivery address</div>
                <div class="ai-req-sub">
                  Don't auto-confirm an order that has no usable address. The AI first tries the
                  customer's known address from past deliveries; if there isn't a trustworthy one,
                  the order is left for a human to call.
                </div>
              </div>
              <ai-switch size="lg" v-model="formData.detail.aiCallCenter.requireAddress" />
            </div>
            <p class="ai-hint" v-if="!formData.detail.aiCallCenter.requireAddress">
              ⚠️ Off = the AI can confirm orders with a placeholder address (“-”), which can't be delivered.
            </p>
          </div>

        </div>
        </transition>
      </div>
      <!-- /TAB: AI Call-Center Agent -->

      <!-- TAB: Notifications -->
      <div v-show="activeTab === 'notifications'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('Notifications') }}</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2"
              for="grid-password">{{ $t('phone') }}</label>
            <input type="text" v-model="formData.detail.phone"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t('Email notifications')}}</label>
            <input type="email" v-model="formData.detail.email"
              class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full px-4 mt-5">
          <div class="flex items-center text-center">
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <label class="block font-medium font-medium text-base cursor-pointer text-blue-500  w-full"
              @click="Open('ModalNotifications')">
              <div
                class="bg-indigo-100 mr-4 inline-block text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md  items-center justify-center font-bold text-lg font-display">
                <span class="align-middle"><i
                    class="large font-bold material-icons align-bottom notification-bell">notifications_active</i></span>
              </div>
              <span class="font-medium text-base text-blue-700 dark:text-blue-800 align-middle">Gestion des
                notifications</span>
            </label>
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
          </div>
        </div>
        <!--  -->
      </div>
      <!--  -->

      </div>
      <!-- /TAB: Notifications -->

      <!-- TAB: Payments -->
      <div v-show="activeTab === 'payments'">
      <!--  -->
      <template v-if="currentUser.type && currentUser.type === 'CEO'">
        <!--  -->
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('Méthodes de payement') }}</h6>
        <!--  -->
        <div class="flex flex-wrap" v-if="formData.paymentMethods">
          <!--  -->
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t('RIB') }}</label>
              <input type="text" :disabled="currentUser.type === 'CEO' ? false : true" v-model="formData.paymentMethods.rib" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
          <!--  -->
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t('Wise email')}}</label>
              <input type="email" :disabled="currentUser.type === 'CEO' ? false : true" v-model="formData.paymentMethods.wise" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
          <!--  -->
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ 'Atlas RIB' }}</label>
              <input type="text" :disabled="currentUser.type === 'CEO' ? false : true" v-model="formData.paymentMethods.atlasRib" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
          <!--  -->
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ 'Atlas wise email' }}</label>
              <input type="email" :disabled="currentUser.type === 'CEO' ? false : true" v-model="formData.paymentMethods.atlasWise" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
          <!--  -->
        </div>
        <!--  -->
      </template>
      <p v-if="!(currentUser.type && currentUser.type === 'CEO')" class="text-gray-400 text-sm italic">
        Payment methods are only configurable by CEO accounts.
      </p>
      <!--  -->
      </div>
      <!-- /TAB: Payments -->

      <!-- TAB: SMS & Security -->
      <div v-show="activeTab === 'security'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Vérification SMS</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-1/6 px-4">
          <!--  -->
          <div class="relative w-full">
            <!--  -->
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t("Activation") }}
            </label>
            <!--  -->
            <p class="flex  w-full py-2">
              <!-- Toggle Button -->
              <label for="toogleS" class="flex items-center cursor-pointer">
                <div class="relative">
                  <input id="toogleS" type="checkbox" class="hidden" v-model="formData.sms.active" />
                  <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                  <div :class="'toggle__dot-1'" class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0">
                  </div>
                </div>
              </label>
            </p>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="formData.sms.active" class="w-5/6 px-4">
          <div class="relative w-full">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">{{ $t("Type d'utilisateur")}} </label>
            <v-select label="name" v-model="formData.sms.roles" :options="roles" multiple
              class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"></v-select>
          </div>
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <hr class="mt-6 border-b-1 border-gray-400">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Blacklist phone number</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full lg:w-4/12 px-4">
          <!--  -->
          <div class="relative w-full my-3">
            <!--  -->
            <div class="border  border-gray-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="cities" class="bg-gray-200 text-gray-700 px-1  uppercase text-xs font-bold">Add phone
                    <img v-if="idWharhouse && idWharhouse.flag" class="h-4 w-5 inline-block ml-2" :src="idWharhouse.flag" />
                  </label>
                  </p>
              </div>
              <!--  -->

              <!--  -->
              <div id="city" class="md:w-full overflow-y-auto h-full flex flex-col items-center p-1">
                <!--  -->
                <div class="w-full">
                  <!--  -->
                  <div class="flex flex-col items-center relative">
                    <!--  -->
                    <div class="w-full">
                      <div class="mt-2 mb-4 p-1 bg-white flex border border-gray-200 rounded">
                        <div class="flex flex-auto flex-wrap"></div>
                        <input v-model="phoneInput" @keyup.enter="trigger" placeholder="Enter phone" class="p-1 px-2 appearance-none outline-none w-full text-gray-800" />
                        <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                          <button @click="addPhones" ref="sendReply" class="cursor-pointer w-6 h-6 text-blue-500 outline-none focus:outline-none"><i class="material-icons">add</i></button>
                        </div>
                      </div>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div v-if="formData.blacklist_phones.length > 0" class="tag_cities">
                      <span v-for="(city, index) in formData.blacklist_phones" :key="index" class="tag label label-info">
                        <span class="text-chip vs-chip--text">{{ city }}</span>
                        <span class="btn-close vs-chip--close" @click="deletePhone(index)" data-role="remove"></span>
                      </span>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div v-else class="py-2">
                      <span class="w-full flex justify-center text-center border-gray-200 text-base">
                        <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                          <span>No Phone added </span>
                        </p>
                      </span>
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
      </div>
      <!-- /TAB: SMS & Security -->
    </div>
    <!--  -->

    <!--  -->
    <div v-if="currentUser.type && currentUser.type == 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <!--  -->
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <!--  -->

      <!-- Seller tab bar -->
      <div class="flex flex-wrap border-b border-gray-300 mb-6">
        <button v-for="tab in sellerTabs" :key="tab.key" @click="activeSellerTab = tab.key" type="button"
          class="px-4 py-3 -mb-px text-sm font-bold uppercase focus:outline-none transition-all duration-150"
          :class="activeSellerTab === tab.key ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'">
          {{ tab.label }}
        </button>
      </div>
      <!-- /Seller tab bar -->

      <!-- SELLER TAB: API -->
      <div v-show="activeSellerTab === 'api'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">{{ $t('API') }}</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <!--  -->
        <div class="w-full md:w-1/2 xl:w-1/2 px-4">
          <!--  -->
          <div class="ant-col">
            <!--  -->
            <div class="ant-row">
              <!--  -->
              <div class="ant-label">
                <label for="key" class="ant-form" title="identité du client">API key</label>
              </div>
              <!--  -->

              <!--  -->
              <div class="ant-col ant-form-item">
                <div class="ant-form-item-control has-success">
                  <span class="ant-form-item-children">
                    <span class="ant-input-group-wrapper">
                      <span class="ant-input-group"><input disabled="" id="key" class="ant-input ant-input-disabled" type="text" :value="currentUser.api ? currentUser.api.key : ''">
                        <span @click="copyIt('key')" class="ant-input-group-addon">
                          <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0  hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166">
                            <path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z">
                            </path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="w-full md:w-1/2 xl:w-1/2 px-4">
          <!--  -->
          <div class="ant-col">
            <!--  -->
            <div class="ant-row">
              <!--  -->
              <div class="ant-label">
                <label for="secret" class="ant-form" title="identité du client">API secret key</label>
              </div>
              <!--  -->

              <!--  -->
              <div class="ant-col ant-form-item">
                <div class="ant-form-item-control has-success">
                  <span class="ant-form-item-children">
                    <span class="ant-input-group-wrapper">
                      <span @click="copyIt('secret')" class="ant-input-group"><input disabled="" id="secret" class="ant-input ant-input-disabled" type="text" :value="currentUser.api ? currentUser.api.secret : ''">
                        <span class="ant-input-group-addon">
                          <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0  hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166">
                            <path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z">
                            </path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      </div>
      <!-- /SELLER TAB: API -->

      <!-- SELLER TAB: Warehouses -->
      <div v-show="activeSellerTab === 'warehouses'">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Warehouses (Country code)</h6>
      <!--  -->
      <div class="container tag-rail">
        <!--  -->
        <div class="rail-container">
          <div class="rail" id="rail">
            <span v-for="(item, index) in currentUser.countries" :key="index" :id="'tag' + index" class="tag"> {{ item.name }}
              (<b class="text-black">{{ item.code }}</b>)</span>
          </div>
        </div>
        <!--  -->
      </div>
      <!--  -->


      <hr class="mt-6 border-b-1 border-gray-400">
      <!--  -->
      <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Prefix Order ID</h6>
      <!--  -->
      <div class="flex flex-wrap">
        <div v-for="(item) in currentUser.prefixs" :key="item.country" class="w-full lg:w-4/12 px-4">
          <div class="border hover:border-green-500 focus-within:border-blue-500 flex flex-wrap items-stretch w-full mb-2 relative h-15 bg-white items-center rounded">
            <div class="flex -mr-px justify-center p-1">
              <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                <span class="select-none mr-2"> <img class="flag-img" :src="$f.getCountryCode(item.country)" /></span>
                <span>{{ `${item.name}_0000X` }}</span>
              </span>
            </div>
            <input type="text" placeholder="....." v-model="item.name" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
          </div>
        </div>
      </div>
      <!--  -->

      </div>
      <!-- /SELLER TAB: Warehouses -->

      <!-- SELLER TAB: Webhook -->
      <div v-show="activeSellerTab === 'webhook'">
      <!--  -->
      <div class="flex items-center justify-between mb-4">
        <h6 class="text-gray-500 text-sm mt-3 font-bold uppercase">Webhook Configuration</h6>
        <div class="flex items-center">
          <span class="text-gray-400 text-xs mr-3">{{ webhooks.length }} / {{ maxWebhooks }}</span>
          <button @click="openAddWebhook" type="button" :disabled="webhooks.length >= maxWebhooks"
            :title="webhooks.length >= maxWebhooks ? ('Limit reached (max ' + maxWebhooks + ')') : ''"
            class="rounded focus:outline-none text-gray-100 px-4 py-2 bg-green-600 hover:bg-green-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed">
            + Add Webhook
          </button>
        </div>
      </div>

      <!-- Webhooks table -->
      <div class="px-2 mb-4">
        <div v-if="webhookListLoading" class="text-gray-400 text-sm italic py-6 text-center bg-white rounded shadow-sm">
          Loading webhooks…
        </div>
        <div v-else-if="webhooks.length === 0" class="text-gray-400 text-sm italic py-6 text-center bg-white rounded shadow-sm">
          No webhooks yet. Click "Add Webhook" to create one.
        </div>
        <div class="w-full overflow-x-auto bg-white rounded shadow-sm">
          <table class="w-full text-sm" style="min-width: 640px;">
            <thead>
              <tr class="text-left text-gray-500 uppercase text-xs border-b">
                <th class="px-3 py-2">Name</th>
                <th class="px-3 py-2">URL</th>
                <th class="px-3 py-2">Method</th>
                <th class="px-3 py-2">Events</th>
                <th class="px-3 py-2">Status</th>
                <th class="px-3 py-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="hook in webhooks" :key="hook._id" class="border-b last:border-0 hover:bg-gray-50">
                <td class="px-3 py-2 text-gray-700 whitespace-nowrap">{{ hook.name || '—' }}</td>
                <td class="px-3 py-2 text-gray-600">
                  <div class="truncate" style="max-width: 260px;" :title="hook.webhookUrl">{{ hook.webhookUrl }}</div>
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  <span class="px-2 py-1 rounded text-xs font-semibold"
                    :class="hook.webhookMethod === 'GET' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'">
                    {{ hook.webhookMethod }}
                  </span>
                </td>
                <td class="px-3 py-2 text-gray-600 text-center">{{ (hook.webhookEvents || []).length }}</td>
                <td class="px-3 py-2 whitespace-nowrap">
                  <span class="px-2 py-1 rounded text-xs font-semibold"
                    :class="hook.active !== false ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'">
                    {{ hook.active !== false ? 'Active' : 'Disabled' }}
                  </span>
                </td>
                <td class="px-3 py-2 text-right whitespace-nowrap">
                  <button @click="testWebhook(hook._id)" :disabled="webhookTestLoading"
                    class="text-blue-600 hover:underline mr-3 disabled:opacity-50" type="button">Test</button>
                  <button @click="openEditWebhook(hook)" class="text-gray-600 hover:underline mr-3" type="button">Edit</button>
                  <button @click="deleteWebhook(hook._id)" :disabled="webhookDeleteLoading"
                    class="text-red-600 hover:underline disabled:opacity-50" type="button">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span v-if="webhookMessage" class="block mt-2 text-sm" :class="webhookMessageType === 'success' ? 'text-green-600' : 'text-red-600'">
          {{ webhookMessage }}
        </span>
      </div>

      <!-- Inline add/edit form panel -->
      <div v-if="webhookFormOpen" class="bg-white rounded shadow-md p-4 mb-4 border border-gray-200">
        <div class="flex items-center justify-between mb-3">
          <span class="text-gray-600 text-sm font-bold uppercase">{{ webhookForm.id ? 'Edit Webhook' : 'New Webhook' }}</span>
          <button @click="closeWebhookForm" class="text-gray-400 hover:text-gray-600" type="button">✕</button>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-4/12 px-2 mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2">Name</label>
            <input type="text" v-model="webhookForm.name" placeholder="e.g. My CRM"
              class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-100 rounded text-sm shadow focus:outline-none w-full">
          </div>
          <div class="w-full lg:w-8/12 px-2 mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2">Webhook URL</label>
            <input type="text" v-model="webhookForm.webhookUrl"
              :placeholder="webhookForm.webhookMethod === 'GET' ? 'https://your-crm.com/postback?order_id={orderId}&status={newStatus}' : 'https://your-api.com/webhook'"
              class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-100 rounded text-sm shadow focus:outline-none w-full">
          </div>
          <div class="w-full lg:w-4/12 px-2 mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2">Method</label>
            <select v-model="webhookForm.webhookMethod"
              class="px-3 py-2 text-gray-700 bg-gray-100 rounded text-sm shadow focus:outline-none w-full">
              <option value="POST">POST (JSON body)</option>
              <option value="GET">GET (URL macros)</option>
            </select>
          </div>
          <div class="w-full lg:w-4/12 px-2 mb-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2">Secret (optional)</label>
            <input type="text" v-model="webhookForm.webhookSecret" placeholder="whsec_xxxx"
              :disabled="webhookForm.webhookMethod === 'GET'"
              class="px-3 py-2 placeholder-gray-400 text-gray-700 bg-gray-100 rounded text-sm shadow focus:outline-none w-full disabled:opacity-50">
          </div>
          <div class="w-full lg:w-4/12 px-2 mb-3 flex items-end">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox" v-model="webhookForm.active" class="form-checkbox h-4 w-4 text-green-600">
              <span class="ml-2 text-gray-700 text-sm">Active</span>
            </label>
          </div>
        </div>

        <div v-if="webhookForm.webhookMethod === 'GET'" class="px-2 mb-3">
          <div class="w-full bg-gray-100 rounded p-3">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-2">Available macros</label>
            <div class="text-gray-500 text-xs leading-6">
              <code v-for="m in webhookMacros" :key="m" class="mr-2">{{ '{' + m + '}' }}</code>
            </div>
          </div>
        </div>

        <div class="px-2 mb-3">
          <label class="block uppercase text-gray-700 text-xs font-bold mb-2 w-full">Subscribed Events</label>
          <div v-for="group in webhookEventGroups" :key="group.title" class="mb-4">
            <div class="flex items-center justify-between mb-2">
              <span class="text-gray-600 text-xs font-bold uppercase">{{ group.title }}</span>
              <button type="button" @click="toggleWebhookGroup(group)"
                class="text-green-600 text-xs font-semibold hover:underline focus:outline-none">
                {{ isWebhookGroupAllSelected(group) ? 'Unselect all' : 'Select all' }}
              </button>
            </div>
            <div class="flex flex-wrap">
              <div v-for="evt in group.events" :key="evt" class="w-full md:w-1/3 mb-2">
                <label class="inline-flex items-center cursor-pointer">
                  <input type="checkbox" :value="evt" v-model="webhookForm.events" class="form-checkbox h-4 w-4 text-green-600">
                  <span class="ml-2 text-gray-700 text-sm">{{ formatEventName(evt) }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap px-2 items-center">
          <button @click="saveWebhook" :disabled="webhookLoading"
            class="rounded focus:outline-none text-gray-100 px-4 py-2 mr-2 bg-green-600 hover:bg-green-700 transition-all duration-300 disabled:opacity-50"
            type="button">{{ webhookLoading ? 'Saving...' : (webhookForm.id ? 'Update' : 'Create') }}</button>
          <button @click="closeWebhookForm"
            class="rounded focus:outline-none text-gray-700 px-4 py-2 bg-gray-200 hover:bg-gray-300 transition-all duration-300"
            type="button">Cancel</button>
        </div>
      </div>
      <!--  -->

      </div>
      <!-- /SELLER TAB: Webhook -->

      <!-- SELLER TAB: Services -->
      <div v-show="activeSellerTab === 'services'">
      <!--  -->
      <h6 class="text-gray-500 mb-10 text-sm mt-3  font-bold uppercase">Services</h6>
      <!--  -->
      <div class="flex flex-col lg:flex-row">
        <!--  -->
        <div class="intro-y flex-1 box py-8 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.confirmation }">
          <!--  -->
          <div class="check">
            <span class="feather-icon select-none relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
                  <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
          </div>
          <!--  -->

          <!--  -->
          <svg class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z" />
          </svg>
          <!--  -->

          <!--  -->
          <div class="text-xl font-medium text-center mt-10">Confirmation</div>
          <!--  -->

          <!--  -->
          <ul class="text-center mt-4">
            <li>
              <a href="#" class="font-semibold">
                <i class="material-icons" style="font-size: 13px;">fiber_manual_record</i>
                {{ $t('Confirmation fees') }} : {{ formData.detail.order.feesConfirmation }} 
                <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </a>
            </li>
          </ul>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="intro-y flex-1 box py-8 lg:ml-5 mb-5 lg:mb-0 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.fulfillement }">
          <!--  -->
          <div class="check">
            <span class="feather-icon select-none relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
          </div>
          <!--  -->

          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd" class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto">
            <path d="M6 23h-3v-10l8.991-8.005 9.009 8.005v10h-3v-9h-12v9zm1-2h10v2h-10v-2zm0-3h10v2h-10v-2zm10-3v2h-10v-2h10zm-5-14.029l12 10.661-1.328 1.493-10.672-9.481-10.672 9.481-1.328-1.493 12-10.661z" />
          </svg>
          <!--  -->

          <!--  -->
          <div class="text-xl font-medium text-center mt-10">Warehouse</div>
          <!--  -->

          <!--  -->
          <ul class="text-center mt-4">
            <li>
              <a href="#" class="font-semibold">
                <i class="material-icons" style="font-size: 13px;">fiber_manual_record</i>
                {{ $t('Fulfillement fees') }} : {{ formData.detail.order.fulfillement_fees }} 
                <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </a>
            </li>
          </ul>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="intro-y flex-1 box py-8 lg:ml-5 cursor-pointer zoom-in" :class="{ active: formData.detailSeller.shipping }">
          <div class="check"><span class="feather-icon select-none relative">
            <svg xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"  stroke-linecap="round" stroke-linejoin="round"  class="feather feather-check w-5 h-5 text-white bg-green-500 rounded-full shadow">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </span>
        </div>
        <!--  -->

        <!--  -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto">
          <path d="M15.744 16.683l.349-.199v1.717l-.349.195v-1.713zm3.414-.227l.342-.196v-1.717l-.343.195v1.718zm-1.429.813l.343-.195v-1.717l-.343.195v1.717zm.578-.329l.349-.199v-1.717l-.349.199v1.717zm-1.152.656l.343-.196v-1.717l-.343.196v1.717zm-.821.467l.343-.195v-1.717l-.343.195v1.717zm6.666-11.122v11.507l-9.75 5.552-12.25-6.978v-11.507l9.767-5.515 12.233 6.941zm-12.236-4.643l-2.106 1.19 8.891 5.234-.002.003 2.33-1.256-9.113-5.171zm1.236 10.59l-9-5.218v8.19l9 5.126v-8.098zm3.493-3.056l-8.847-5.208-2.488 1.405 8.86 5.138 2.475-1.335zm5.507-.696l-7 3.773v8.362l7-3.985v-8.15z" />
        </svg>
        <!--  -->

        <!--  -->
        <div class="text-xl font-medium text-center mt-10">Shipping</div>
        <!--  -->

        <!--  -->
          <ul class="text-center mt-4">
            <!--  -->
            <li v-if="coutryW != 'MA'"><a href="#" class="font-semibold">
              <i class="material-icons" style="font-size: 13px;">fiber_manual_record</i> {{ $t('Shipping fees') }} :
                {{ formData.detail.shipping.fees }}<sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </a>
            </li>
            <!--  -->

            <!--  -->
            <li>
              <a href="#" class="font-semibold"><i class="material-icons" style="font-size: 13px;">fiber_manual_record</i>
                {{ $t('Return fees') }} : {{ formData.detail.shipping.refund }} <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
              </a>
            </li>
            <!--  -->

            <!--  -->
            <li><a href="#" class="font-semibold">
              <i class="material-icons"  style="font-size: 13px;">fiber_manual_record</i>
                {{ $t('Cancelation fees') }} : {{ formData.detail.shipping.cancelation }} 
                <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup></a>
              </li>
          </ul>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
      </div>
      <!-- /SELLER TAB: Services -->
    </div>
    <!--  -->

    <!--  -->
    <div class="settings-save-bar flex justify-end px-4 lg:px-8 py-3 mb-4">
      <button @click="save" class="rounded focus:outline-none outline-none text-gray-100 px-8 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300">
        {{ $t('Save settings') }}
      </button>
    </div>
    <!--  -->

    <vue-modal-2 name="ModalNotifications" :headerOptions="{ title: 'Gestion des notifications pour les SELLERS' }" :noFooter="true" modalSize="lg" @on-close="close('ModalNotifications')">
      <!--  -->
      <div class="bg-white rounded-lg">
        <!--  -->
        <div class="bg-white px-4 pt-0 pb-1 mb-20">
          <!--  -->
          <div class="invoice-item-list">
            <!--  -->
            <table class="table invoice-table  invoice-table-edit">
              <!--  -->
              <thead class="thead">
                <tr>
                  <th class="invoice-detail-margin">&nbsp;</th>
                  <th class="invoice-detail-quantity bg-gray-50">Texte</th>
                </tr>
              </thead>
              <!--  -->

              <!--  -->
              <tbody class="invoice-items">
                <!--  -->
                <tr class="item-row item-row-1 with-tax" v-for="(notif, index) in formData.notifications" :key="index">
                  <!--  -->
                  <td class="item-row-actions" style="text-align: center !important;vertical-align: middle !important;">
                    <div class="confirm-delete-button">
                      <button :disabled="loadingNotif" @click="addNotif(index, 'remove', notif)" title="Remove Item" class="btn btn-remove">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                          <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                          </path>
                        </svg>
                      </button>
                    </div>
                  </td>
                  <!--  -->

                  <!--  -->
                  <td data-label="Quantity" class="item-row-quantity">
                    <!--  -->
                    <div class="w-full rounded-md inline-flex border mb-2">
                      <v-select placeholder="Warehouses ..." :disabled="notif._id ? true : false" v-model="notif.warehouses" multiple :options="warehouses" label="name" class="w-full focus:outline-none border border-gray-400  bg-white  text-gray-700 focus:text-gray-600 p-2">
                        <template slot="option" slot-scope="option">
                          <img class="flag-img" :src="$f.getCountryCode(option.country)" />
                          {{ option.name }}
                        </template>
                      </v-select>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full rounded-md border mt-2">
                      <!--  -->
                      <div class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <!--  -->
                        <div class="-mt-4 absolutes tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="outOfStock" class="bg-white text-gray-700 px-1">{{ $t('Langue arabe') }}</label>
                          </p>
                        </div>
                        <!--  -->

                        <!--  -->
                        <p class="flex items-center justify-center w-full py-2">
                          <label :for="'toogle' + index" class="flex items-center cursor-pointer">
                            <div class="relative">
                              <input :id="'toogle' + index" type="checkbox" class="hidden" :disabled="notif._id ? true : false" v-model="notif.rtl" />
                              <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                              <div :class="'toggle__dot-' + index"
                                class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                            </div>
                            <div class="ml-3 text-gray-700 capitalize">{{ $t(notif.rtl) }}</div>
                          </label>
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full rounded-md border mt-4">
                      <!--  -->
                      <div class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <!--  -->
                        <div class="-mt-4 absolutes tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="outOfStock" class="bg-white text-gray-700 px-1">{{ $t('pop-up') }}</label>
                          </p>
                        </div>
                        <!--  -->

                        <!--  -->
                        <p class="flex items-center justify-center w-full py-2">
                          <label :for="'toogleP' + index" class="flex items-center cursor-pointer">
                            <div class="relative">
                              <input :id="'toogleP' + index" type="checkbox" class="hidden" :disabled="notif._id ? true : false" v-model="notif.isPopup" />
                              <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                              <div :class="'toggle__dot-' + index"
                                class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                            </div>
                            <div class="ml-3 text-gray-700 capitalize">{{ $t(notif.isPopup) }}</div>
                          </label>
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full rounded-md border mt-4">
                      <vue-editor :class="notif.rtl ? 'isrtl' : ''" :disabled="notif._id ? true : false" v-model="notif.text"></vue-editor>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div v-if="notif.text" class="border mt-4 hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label class="bg-white text-gray-700 px-1">Preview</label>
                        </p>
                      </div>
                      <!--  -->
                      <div class="preview relative">
                        <!--  -->
                        <div v-if="notif.isPopup" class="popup-notif bg-white text-base shadow-xl px-5 py-4 rounded-md cursor-pointer overflow-auto">
                          <span class="font-semibold" :class="notif.rtl ? 'rtl-direction text-right' : ''" v-html="notif.text"></span>
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="preview-text" v-else>
                          <notif-bar :classDiv="'alert-cod alert alert-absolute mainta'" :text="notif" preview="true" />
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="preview-header w-full">
                          <img alt="preview" src="https://storeno.b-cdn.net/codinafrica-v1/7-2024/1721388674258.png" /></div>
                        </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </td>
                  <!--  -->
                </tr>
                <!--  -->

                <!--  -->
                <tr class="item-row item-row-n">
                  <td v-if="formData.notifications.length === 0 || (formData.notifications.length === 1 && formData.notifications[0]._id)" class="item-row-actions" colspan="2">
                    <button :disabled="loadingNotif" id="invoice-item-add" @click="addNotif(null, 'add')" title="Add Item" class="btn btn-prime animation-pulse"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="svg-inline--fa fa-plus fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                        </path>
                      </svg>
                    </button>
                  </td>
                </tr>
                <!--  -->
              </tbody>
              <!--  -->
            </table>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <button @click="close('ModalNotifications')" :disabled="loadingNotif" :class="loadingNotif ? 'noselect' : ''" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Fermer</button>
          <!--  -->
          <button @click="save('Notifications')" :disabled="loadingNotif" :class="loadingNotif ? 'noselect' : ''" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">
            <loading :active.sync="loadingNotif" :is-full-page="fullPage"></loading> Envoyer
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </vue-modal-2>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const PNF = require('google-libphonenumber').PhoneNumberFormat;
import { VueEditor } from "vue2-editor";
import AiSwitch from "../../components/ui/AiSwitch.vue";
import AiSegmented from "../../components/ui/AiSegmented.vue";
import AiSlider from "../../components/ui/AiSlider.vue";
import TelephonySettings from "../telephony/Settings.vue";
import countriesList from "../../assets/data/countries.json"; // code → name for the AI-agent warehouse banner

export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  components: {
    VueEditor,
    AiSwitch,
    AiSegmented,
    AiSlider,
    TelephonySettings,
  },
  data() {
    return {
      activeTab: 'fees',
      activeSellerTab: 'api',
      aiSellers: [], // seller list for the AI-agent scope picker (lazy loaded)
      adminTabs: [
        { key: 'fees', label: 'Fees' },
        { key: 'quality', label: 'Quality & Conversion' },
        { key: 'callcenterAi', label: '🤖 AI Agent' },
        { key: 'notifications', label: 'Notifications' },
        { key: 'payments', label: 'Payments' },
        { key: 'security', label: 'SMS & Security' },
        { key: 'telephony', label: 'Telephony' }
      ],
      sellerTabs: [
        { key: 'api', label: 'API' },
        { key: 'warehouses', label: 'Warehouses' },
        { key: 'webhook', label: 'Webhook' },
        { key: 'services', label: 'Services' }
      ],
      formData: {
        details: [],
        dataUser: [],
        detailSeller: {
          open_colis: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
        },
        detail: {
          shipping: {
            fees: 0,
          },
          order: {
            feesConfirmation: 0,
            fulfillement_fees: 0,
          },
          quality_control: 0,
          phone: null, email: null,
          info: { mad: 1, currency: 1, currencyCredit: 1, },
        },
        tva: [],
        blacklist_phones: [],
        notifications: [],
        sms: { active: false, roles: [] }
      },
      detail: {
        shipping: {
          fees: 0,
        },
        order: {
          feesConfirmation: 0,
          fulfillement_fees: 0,
        },
        quality_control: 0,
        phone: null, email: null,
        info: { mad: 1, currency: 1, currencyCredit: 1 },
      },
      detailSeller: {
        open_colis: false,
        confirmation: false,
        fulfillement: false,
        shipping: false,
      },
      loading: false,
      loadingNotif: false,
      fullPage: false,
      tvaInput: "",
      currency: "",
      options: this.$countries,
      cities: [],
      coutryW: "",
      phoneInput: "",
      roles: [],
      warehouses: [],
      webhooks: [],
      maxWebhooks: 10,
      webhookListLoading: true,
      webhookFormOpen: false,
      webhookForm: { id: null, name: '', webhookUrl: '', webhookSecret: '', webhookMethod: 'POST', events: [], active: true },
      webhookEventGroups: [
        {
          title: 'Order Events',
          events: ['order.created', 'order.status_changed']
        },
        {
          title: 'Shipping Events',
          events: ['shipping.created', 'shipping.status_changed', 'shipping.delivered', 'shipping.returned']
        },
        {
          title: 'Shipping Status Events',
          events: [
            'shipping.status.to_prepare',
            'shipping.status.awaiting_paid',
            'shipping.status.prepared',
            'shipping.status.outofstock',
            'shipping.status.shipped',
            'shipping.status.delivered',
            'shipping.status.paid',
            'shipping.status.processed',
            'shipping.status.cancelled',
            'shipping.status.refused',
            'shipping.status.remind',
            'shipping.status.unreachable',
            'shipping.status.pending_return',
            'shipping.status.return',
            'shipping.status.to_pick',
            'shipping.status.picked',
            'shipping.status.rembourser',
            'shipping.status.reprogrammer'
          ]
        }
      ],
      webhookMacros: [
        'event', 'orderId', 'externalId', 'orderNumber', 'oldStatus', 'newStatus',
        'totalPrice', 'trackingNumber', 'shippingId', 'deliveredAt', 'returnedAt',
        'reason', 'metadata.webmasterId', 'customer.fullName', 'customer.phone', 'customer.city'
      ],
      webhookLoading: false,
      webhookTestLoading: false,
      webhookDeleteLoading: false,
      webhookMessage: '',
      webhookMessageType: ''
    };
  },

  async mounted() {
    await this.getSettings();
    await this.getCities();
    if (this.currentUser.type === 'Seller') this.loadWebhookConfig();
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({ user: _.pick(this.currentUser, ['countries']) })
    },
    // Warehouse display name for the AI-agent banner. idWharhouse.country is the
    // 2-letter code (e.g. "CI") — map it to the full country name via countries.json.
    // NEVER fall back to warhouseSelected (it's an async getter → Promise).
    whName() {
      const w = this.idWharhouse || {};
      if (w.countryName) return w.countryName;
      if (w.name) return w.name;
      const code = w.country || w.code;
      if (code) {
        try {
          const match = (countriesList || []).find(c => c.code === code);
          if (match && match.name) return match.name;
        } catch (e) { /* ignore */ }
        return code; // last resort: show the code
      }
      return '—';
    },
    whFlag() {
      const w = this.idWharhouse || {};
      return w.flag || '';
    },
    // The single store list behind the Only/Except switch. It reads and writes the
    // field that matches the current mode (sellers = allow-list, blockedSellers =
    // blocklist), so exactly ONE of them is ever populated and a store can never be
    // allowed and blocked at once. The stored shape is unchanged, so the backend
    // gate needs no special case.
    aiScopeSellers: {
      get() {
        const ai = (this.formData && this.formData.detail && this.formData.detail.aiCallCenter) || {};
        const list = ai.sellerMode === 'except' ? ai.blockedSellers : ai.sellers;
        return Array.isArray(list) ? list : [];
      },
      set(val) {
        const ai = this.formData.detail.aiCallCenter;
        const list = Array.isArray(val) ? val : [];
        if (ai.sellerMode === 'except') {
          this.$set(ai, 'blockedSellers', list);
          this.$set(ai, 'sellers', []);   // never keep a stale allow-list
        } else {
          this.$set(ai, 'sellers', list);
          this.$set(ai, 'blockedSellers', []);
        }
      },
    },
  },
  watch: {
    'warhouseSelected': async function (oldVal, newVal) {
      await this.getSettings();
      await this.getCities();
    },
    'formData.sms.active': async function (oldVal, newVal) {
      if (this.roles.length == 0 && oldVal && this.currentUser.type != 'Seller') await this.getRoles();
    },
    // Refresh the webhook list whenever the seller opens the Webhook tab
    'activeSellerTab': function (val) {
      if (val === 'webhook' && this.currentUser.type === 'Seller') this.loadWebhookConfig();
    },
    // Load the seller list when the AI Agent tab opens (for the scope picker)
    'activeTab': function (val) {
      if (val === 'callcenterAi' && this.aiSellers.length === 0) this.loadAiSellers();
    },
    // Flipping Only <-> Except carries the picked stores over to the other field,
    // so the selection you can see is always the one that gets saved (and the
    // field you are no longer using is cleared).
    'formData.detail.aiCallCenter.sellerMode': function (mode, prev) {
      if (!prev || mode === prev) return;
      const ai = this.formData && this.formData.detail && this.formData.detail.aiCallCenter;
      if (!ai) return;
      const carried = (prev === 'except' ? ai.blockedSellers : ai.sellers) || [];
      if (mode === 'except') {
        this.$set(ai, 'blockedSellers', carried);
        this.$set(ai, 'sellers', []);
      } else {
        this.$set(ai, 'sellers', carried);
        this.$set(ai, 'blockedSellers', []);
      }
    }
  },
  methods: {
    async loadAiSellers() {
      try {
        // List sellers for the current warehouse's country (same proven pattern
        // other admin pages use: users/search type Seller). getAllSeller lives in
        // the analytics module and needs country+DateType, so it's the wrong tool.
        const country = this.idWharhouse && this.idWharhouse.country;
        const res = await this.$server.search('users', { type: 'Seller', countries: country, limit: 1000 });
        // users/search returns paginated content.results (see expeditions/chart.vue)
        this.aiSellers = (res && res.content && res.content.results) ? res.content.results : [];
      } catch (e) { console.log('loadAiSellers error', e && e.message); }
    },
    close(name) {
      if (this.loadingNotif) return false
      this.$vm2.close(name);
    },
    async addNotif(index, type, notif) {
      if (type === 'add') {
        this.formData.notifications.push({ text: '', warehouses: [] })
      } else {
        if (notif._id) {
          await this.saveNotif({ _id: this.formData._id, notifications: [], action: 'Notifications' });
        } else this.formData.notifications.splice(index, 1);
      }
    },
    trigger() {
      this.$refs.sendReply.click();
    },
    async getRoles() {
      const res = await this.$server.search("roles", { limit: 10 });
      if (res && res.content.results) {
        this.roles = res.content.results;
      } else this.roles = [];
    },
    async Open(name) {
      this.$vm2.open(name);
      await this.getwarehouses();
    },
    async getwarehouses() {
      var newArray = []
      const res = await this.$server.search("warehouses", { limit: 100 });
      if (res && res.content.results) this.warehouses = res.content.results;

      this.currentUser.countries.forEach(arg => {
        newArray.push(this.warehouses.find(x => x.country === (arg.code || arg)))
      });
      this.warehouses = newArray
    },
    copyIt: function (id) {
      document.getElementById(id).removeAttribute('disabled');
      let copyInput = document.querySelector('#' + id);
      copyInput.select();
      document.execCommand("copy");
      document.getElementById(id).setAttribute('disabled', true);
    },
    addPhones(index) {
      if (this.phoneInput === "" || this.phoneInput === null || this.phoneInput.value === 0) {
        alert(`Please enter phone in text box below !! `, "warning");
      } else {
        let tel = phoneUtil.parse(this.phoneInput, this.idWharhouse.country);
        tel = phoneUtil.format(tel, PNF.E164);
        this.formData.blacklist_phones.push(tel);
        this.phoneInput = "";
      }
    },
    deletePhone(index) {
      this.formData.blacklist_phones.splice(index, 1);
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getCities() {
      const resCities = await this.$server.get("zones", { allCitiesAndFees: true, country: await this.warhouseSelected });
      if (resCities.content.length > 0 && await this.warhouseSelected === "MA") this.cities = resCities.content;
      else this.cities = [];
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
        this.currency = res;
      })
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    addTva() {
      if (this.tvaInput === "" || this.tvaInput === null || this.tvaInput.value === 0) {
        alert(`Please enter tva in text box below !! `, "warning");
      } else if (isNaN(this.tvaInput)) {
        alert(`Please enter a number value`, "warning");
      } else {

        this.formData.tva.push(this.tvaInput);
        this.tvaInput = "";
      }
    },
    deleteTva(index) {
      this.formData.tva.splice(index, 1);
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId', { country: await this.warhouseSelected }).then((res) => {
        this.idWharhouse = res;
      })
    },
    async changeData(data, warhouse, element) {
      for (var i in data) {
        if (data[i].warehouse == warhouse.toString()) {
          data[i] = element;
          break; //Stop this loop, we found it!
        }
      }
    },
    async saveNotif(dataBody) {
      this.loadingNotif = true;
      const data = await this.$server.update("settings", dataBody);
      this.loadingNotif = false;
      if (data && data._id) {
        this.$toast.success(this.$t('Notification a été envoyé avec succès'));
        this.loadingNotif = true;
        await this.getSettings();
        this.loadingNotif = false;
      } else this.$toast.warning(data);
    },
    async save(name) {
      // The Telephony tab has its own backend (telephony/updateSettings) — the two
      // "Save settings" buttons above/below the tabs must save IT when that tab is open
      // (settings/update below never carries the telephony fields).
      if (this.activeTab === 'telephony' && this.currentUser.type !== 'Seller' && this.$refs.telephonySettings) {
        return this.$refs.telephonySettings.save();
      }
      //get data current warhouse
      if (this.currentUser.type !== "Seller") {
        let data = null;

        if (name && name === 'Notifications') {
          if (this.formData.notifications.length === 0) {
            this.$toast.warning('No Text addes !!!');
            return false;
          }
          for (let index = 0; index < this.formData.notifications.length; index++) {
            const expeditionLine = this.formData.notifications[index];
            if (!expeditionLine.text) {
              this.$toast.warning('Text message required !!');
              return false;
            }
            if (!expeditionLine.warehouses || (expeditionLine.warehouses && expeditionLine.warehouses.length === 0)) {
              this.$toast.warning('Warehouses required !!');
              return false;
            }
          }

          this.$confirm(this.$t("Confirmer l'envoi du Notification aux vendeurs")).then(
            async (res) => {
              if (res) {
                await this.saveNotif({ _id: this.formData._id, notifications: this.formData.notifications, action: 'Notifications' });
              }
            }
          );

          return false;
        } else {
          const dataWahrhouse = await this.$server.get("settings", { warehouse: this.idWharhouse._id });
          if (dataWahrhouse.content.length > 0) {
            this.formData.action = "Update";
          } else {
            this.formData.action = "Add";
          }
          this.formData.detail.warehouse = this.idWharhouse._id;
          this.formData.detail.country = this.idWharhouse.country;

          data = await this.$server.update("settings", this.formData);
        }


        if (data && data._id) {
          this.$toast.success(this.$t('setting_updated'));
          await this.getSettings();
        } else this.$toast.warning(data);
      } else {
        const data = await this.$server.update('users', { _id: this.currentUser._id, prefixs: this.currentUser.prefixs.filter(x => x.name) });
        if (data && data._id) {
          this.$toast.success(this.$t('setting_updated'));
          await this.getSettings();
        } else this.$toast.warning(data);
      }
    },
    async getSettings() {
      this.coutryW = await this.warhouseSelected
      this.loading = true;
      const data = await this.$server.get("settings");
      this.loading = false;
      const dataWahrhouse = await this.$server.get("settings", { warehouse: this.idWharhouse._id });
      this.formData.tva = data.content.tva;
      this.formData._id = data.content._id;
      this.formData.details = data.content.details;
      if (!data.content.blacklist_phones) this.formData.blacklist_phones = [];
      else this.formData.blacklist_phones = data.content.blacklist_phones;

      if (!data.content.notifications) this.formData.notifications = [];
      else this.formData.notifications = data.content.notifications;

      if (!data.content.sms) this.formData.sms = { active: false, roles: [] };
      else this.formData.sms = data.content.sms;

      if (!data.content.paymentMethods) this.formData.paymentMethods = {};
      else this.formData.paymentMethods = data.content.paymentMethods;



      if (dataWahrhouse.content.length > 0) {
        const currentSettingW = this.getElementInArray(dataWahrhouse.content[0].details, this.idWharhouse._id);
        if (!currentSettingW.info) currentSettingW.info = { mad: 1, currency: 1, currencyCredit: 1 };
        this.formData.detail = currentSettingW;
      } else this.formData.detail = { shipping: { fees: 0, }, order: { feesConfirmation: 0, fulfillement_fees: 0 }, quality_control: 0, phone: null, email: null, info: { mad: 1, currency: 1, currencyCredit: 1 }, };

      // AI Call-Center Agent — default the config when a warehouse has none yet, so
      // the form binds to a real object (else v-model writes undefined and the save
      // round-trip would drop it). Defaults keep it OFF + shadow.
      if (!this.formData.detail.aiCallCenter) {
        this.$set(this.formData.detail, 'aiCallCenter', {
          active: false, mode: 'shadow', threshold: 0.85,
          pricePerProcessed: 0.40, scope: 'all', sellers: [], blockedSellers: [],
          sellerMode: 'only', requireAddress: true,
        });
      }
      // Configs saved before the blocklist shipped have no blockedSellers key —
      // seed it so v-model binds to a real array instead of writing undefined
      // (which the save round-trip would drop).
      if (!Array.isArray(this.formData.detail.aiCallCenter.blockedSellers)) {
        this.$set(this.formData.detail.aiCallCenter, 'blockedSellers', []);
      }
      // Infer the Only/Except switch from what was actually saved, so an existing
      // blocklist reopens on the right side instead of silently looking empty.
      if (!this.formData.detail.aiCallCenter.sellerMode) {
        const ai = this.formData.detail.aiCallCenter;
        const hasBlocked = Array.isArray(ai.blockedSellers) && ai.blockedSellers.length > 0;
        this.$set(ai, 'sellerMode', hasBlocked ? 'except' : 'only');
      }
      // Existing configs saved before the address gate shipped have no
      // requireAddress key — seed it so the toggle binds (and the save
      // round-trip keeps it) instead of writing undefined.
      if (this.formData.detail.aiCallCenter.requireAddress === undefined) {
        this.$set(this.formData.detail.aiCallCenter, 'requireAddress', false);
      }

      if (this.currentUser.type === "Seller") {
        const currentSettingW = this.getElementInArray(this.currentUser.settings, this.idWharhouse._id);
        if (!currentSettingW) this.formData.detailSeller = { open_colis: false, confirmation: false, fulfillement: false, shipping: false, };
        else this.formData.detailSeller = currentSettingW;

        if (!this.currentUser.prefixs) this.currentUser.prefixs = [];
        this.currentUser.countries.forEach(arg => {
          var index = this.currentUser.prefixs.findIndex(x => x.country === arg.code)
          if (index === -1) this.currentUser.prefixs.push({ name: "", country: arg.code });
        });

      } else {
        if (this.formData.sms.active) await this.getRoles();
      }
    },
    async loadWebhookConfig() {
      this.webhookListLoading = true;
      try {
        const data = await this.$server.listSellerWebhooks('users', {});
        if (data && data.content && Array.isArray(data.content.webhooks)) {
          this.webhooks = data.content.webhooks;
        } else {
          this.webhooks = [];
        }
      } catch (e) {
        console.log('loadWebhookConfig error', e);
      }
      this.webhookListLoading = false;
    },
    openAddWebhook() {
      if (this.webhooks.length >= this.maxWebhooks) {
        this.webhookMessage = 'Limit reached (max ' + this.maxWebhooks + ' webhooks)';
        this.webhookMessageType = 'error';
        return;
      }
      this.webhookMessage = '';
      this.webhookForm = { id: null, name: '', webhookUrl: '', webhookSecret: '', webhookMethod: 'POST', events: [], active: true };
      this.webhookFormOpen = true;
    },
    openEditWebhook(hook) {
      this.webhookMessage = '';
      this.webhookForm = {
        id: hook._id,
        name: hook.name || '',
        webhookUrl: hook.webhookUrl || '',
        webhookSecret: hook.webhookSecret || '',
        webhookMethod: hook.webhookMethod || 'POST',
        events: (hook.webhookEvents || []).slice(),
        active: hook.active !== false
      };
      this.webhookFormOpen = true;
    },
    closeWebhookForm() {
      this.webhookFormOpen = false;
    },
    async saveWebhook() {
      this.webhookLoading = true;
      this.webhookMessage = '';
      const payload = {
        name: this.webhookForm.name,
        webhookUrl: this.webhookForm.webhookUrl,
        webhookSecret: this.webhookForm.webhookSecret,
        webhookMethod: this.webhookForm.webhookMethod,
        events: this.webhookForm.events,
        active: this.webhookForm.active
      };
      try {
        let data;
        if (this.webhookForm.id) {
          payload.id = this.webhookForm.id;
          data = await this.$server.updateSellerWebhook('users', payload);
        } else {
          data = await this.$server.addSellerWebhook('users', payload);
        }
        // Success returns { success:true, webhooks:[...] }; validation errors return a string.
        if (data && data.content && data.content.success) {
          this.webhooks = data.content.webhooks || this.webhooks;
          this.webhookMessage = this.webhookForm.id ? 'Webhook updated' : 'Webhook created';
          this.webhookMessageType = 'success';
          this.webhookFormOpen = false;
        } else {
          this.webhookMessage = (data && typeof data.content === 'string' && data.content) || 'Save failed';
          this.webhookMessageType = 'error';
        }
      } catch (e) {
        this.webhookMessage = 'Save failed';
        this.webhookMessageType = 'error';
      }
      this.webhookLoading = false;
    },
    async deleteWebhook(id) {
      if (!confirm('Delete this webhook? Events will stop being sent to it.')) return;
      this.webhookDeleteLoading = true;
      this.webhookMessage = '';
      try {
        const data = await this.$server.deleteSellerWebhook('users', { id });
        if (data && data.content && data.content.success) {
          this.webhooks = data.content.webhooks || [];
          this.webhookMessage = 'Webhook deleted';
          this.webhookMessageType = 'success';
          if (this.webhookForm.id === id) this.webhookFormOpen = false;
        } else {
          this.webhookMessage = (data && typeof data.content === 'string' && data.content) || 'Delete failed';
          this.webhookMessageType = 'error';
        }
      } catch (e) {
        this.webhookMessage = 'Delete failed';
        this.webhookMessageType = 'error';
      }
      this.webhookDeleteLoading = false;
    },
    async testWebhook(id) {
      this.webhookTestLoading = true;
      this.webhookMessage = '';
      try {
        const data = await this.$server.testSellerWebhook('users', { id });
        const ok = data && data.content && data.content.success;
        this.webhookMessage = ok
          ? 'Test webhook sent successfully!'
          : ((data && data.content && data.content.message) || 'Test failed');
        this.webhookMessageType = ok ? 'success' : 'error';
      } catch (e) {
        this.webhookMessage = 'Test failed';
        this.webhookMessageType = 'error';
      }
      this.webhookTestLoading = false;
    },
    formatEventName(event) {
      const names = {
        'order.created': 'Order Created',
        'order.status_changed': 'Order Status Changed',
        'shipping.created': 'Shipping Created',
        'shipping.status_changed': 'Shipping Status Changed',
        'shipping.delivered': 'Delivered',
        'shipping.returned': 'Returned'
      };
      if (names[event]) return names[event];
      // shipping.status.pending_return -> "Pending Return"
      if (event.indexOf('shipping.status.') === 0) {
        const slug = event.replace('shipping.status.', '').replace(/_/g, ' ');
        return slug.replace(/\b\w/g, (c) => c.toUpperCase());
      }
      return event;
    },
    isWebhookGroupAllSelected(group) {
      return group.events.every((e) => this.webhookForm.events.includes(e));
    },
    toggleWebhookGroup(group) {
      if (this.isWebhookGroupAllSelected(group)) {
        // unselect all events in this group
        this.webhookForm.events = this.webhookForm.events.filter((e) => !group.events.includes(e));
      } else {
        // add any missing events from this group
        const set = new Set(this.webhookForm.events);
        group.events.forEach((e) => set.add(e));
        this.webhookForm.events = Array.from(set);
      }
    },
  },
};
</script>

<style scoped>
/* ══════════ AI Call-Center Agent tab ══════════ */
.ai-tab { padding: 8px 4px 20px; }
/* hero */
.ai-hero {
  display: flex; gap: 16px; align-items: flex-start;
  background: linear-gradient(135deg, #eef4ff 0%, #f5f0ff 100%);
  border: 1px solid #e2e8f0; border-radius: 16px; padding: 18px 20px; margin-bottom: 18px;
}
.ai-hero-icon {
  font-size: 30px; width: 54px; height: 54px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: #fff; border-radius: 14px; box-shadow: 0 2px 8px rgba(37,99,235,.12);
}
.ai-hero-text h3 { font-size: 17px; font-weight: 700; color: #1e293b; margin: 2px 0 4px; display: flex; align-items: center; gap: 8px; }
.ai-hero-wh { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #2563eb; background: #dbeafe; padding: 2px 8px; border-radius: 20px; }
/* per-warehouse context banner */
.ai-wh-banner { display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap;
  background: #fff; border: 1px solid #e5e7eb; border-left: 4px solid #2563eb;
  border-radius: 12px; padding: 12px 16px; margin-bottom: 16px; }
.ai-wh-left { display: flex; align-items: center; gap: 12px; }
.ai-wh-flag { width: 34px; height: 24px; border-radius: 4px; object-fit: cover; box-shadow: 0 1px 2px rgba(0,0,0,.12); }
.ai-wh-flag-fallback { font-size: 22px; line-height: 1; }
.ai-wh-label { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: #94a3b8; }
.ai-wh-name { font-size: 16px; font-weight: 700; color: #1e293b; display: flex; align-items: center; gap: 8px; }
.ai-wh-cur { font-size: 11px; font-weight: 600; color: #2563eb; background: #dbeafe; padding: 2px 8px; border-radius: 20px; }
.ai-wh-hint { font-size: 11.5px; color: #94a3b8; max-width: 300px; text-align: right; line-height: 1.4; }
.ai-hero-text p { font-size: 13px; color: #64748b; line-height: 1.55; margin: 0; max-width: 66ch; }
.ai-hero-text b { color: #16a34a; }
/* generic card */
.ai-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 14px; padding: 16px 18px; box-shadow: 0 1px 2px rgba(0,0,0,.04); }
.ai-card-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.ai-card-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: #475569; }
.ai-pill { font-size: 10.5px; font-weight: 700; padding: 3px 9px; border-radius: 20px; letter-spacing: .03em; }
.pill-live { background: #dcfce7; color: #15803d; }
.pill-shadow { background: #f1f5f9; color: #64748b; }
.pill-neutral { background: #dbeafe; color: #1d4ed8; }
.ai-hint { font-size: 11.5px; color: #94a3b8; margin: 10px 0 0; line-height: 1.5; }
.ai-warn { font-size: 12px; color: #b45309; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 8px 10px; margin: 10px 0 0; line-height: 1.5; }
/* activation card */
.ai-activate { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; transition: border-color .2s, background .2s; }
.ai-activate.on { border-color: #bbf7d0; background: #f7fef9; }
.ai-activate-left { display: flex; align-items: center; gap: 14px; }
.ai-status-dot { width: 12px; height: 12px; border-radius: 50%; background: #cbd5e1; flex-shrink: 0; }
.ai-status-dot.on { background: #22c55e; box-shadow: 0 0 0 4px rgba(34,197,94,.18); }
.ai-activate-title { font-size: 15px; font-weight: 700; color: #1e293b; }
.ai-activate-sub { font-size: 12.5px; color: #64748b; margin-top: 1px; }
/* require-address card */
.ai-req-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.ai-req-text { flex: 1; min-width: 0; }
.ai-req-title { font-size: 14px; font-weight: 700; color: #1e293b; }
.ai-req-sub { font-size: 12.5px; color: #64748b; margin-top: 3px; line-height: 1.5; }
/* grid */
.ai-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media (max-width: 900px) { .ai-grid { grid-template-columns: 1fr; } }
/* price input */
.ai-price { display: flex; align-items: center; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 0 12px; }
.ai-price.is-disabled { background: #f1f3f6; border-color: #e2e6ea; opacity: .8; }
.ai-price.is-disabled input { cursor: not-allowed; color: #64748b; }
.ai-price-cur { color: #64748b; font-weight: 700; font-size: 15px; }
.ai-price input { flex: 1; border: 0; background: none; outline: none; font-size: 18px; font-weight: 700; color: #1e293b; padding: 11px 8px; width: 100%; }
.ai-price-unit { color: #94a3b8; font-size: 12px; font-weight: 600; }
/* sellers */
.ai-sellers { margin-top: 12px; }
/* the store picker sat flush against the Only/Except switch above it */
.ai-sellers .ai-seller-select { margin-top: 12px; }
.ai-sellers-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.ai-sellers-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #64748b; }
.ai-sellers-count { font-size: 11px; font-weight: 700; color: #1d4ed8; background: #dbeafe; padding: 2px 9px; border-radius: 20px; }
/* blocked = red, so it never reads as just another selection */
.ai-blocked-count { margin-left: auto; font-size: 11px; font-weight: 700; color: #dc2626; background: #fee2e2; padding: 2px 9px; border-radius: 20px; }
.ai-opt-avatar.blocked { background: #fee2e2; color: #dc2626; }
/* stores can share a name — the email is what tells two accounts apart */
.ai-opt-col { display: flex; flex-direction: column; line-height: 1.25; min-width: 0; }
.ai-opt-mail { font-size: 11px; color: #94a3b8; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* dropdown option row */
.ai-opt { display: flex; align-items: center; gap: 10px; padding: 2px 0; }
.ai-opt-avatar { width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700;
  color: #fff; background: linear-gradient(135deg, #60a5fa, #6366f1); }
.ai-opt-name { font-size: 13.5px; color: #334155; }

/* ── restyle vue-select (global .vs__* classes) inside the AI seller picker ── */
.ai-seller-select >>> .vs__dropdown-toggle {
  border: 1px solid #e2e8f0; border-radius: 12px; padding: 5px 8px; background: #fff;
  min-height: 46px; transition: border-color .15s, box-shadow .15s;
}
.ai-seller-select.vs--open >>> .vs__dropdown-toggle,
.ai-seller-select >>> .vs__dropdown-toggle:focus-within {
  border-color: #93c5fd; box-shadow: 0 0 0 3px rgba(59,130,246,.12);
}
.ai-seller-select >>> .vs__search, .ai-seller-select >>> .vs__search:focus {
  font-size: 13.5px; color: #334155; margin: 4px 0; padding: 0 4px;
}
.ai-seller-select >>> .vs__search::placeholder { color: #94a3b8; }
/* selected chips */
.ai-seller-select >>> .vs__selected {
  background: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af;
  border-radius: 8px; padding: 3px 4px 3px 10px; margin: 3px; font-size: 12.5px; font-weight: 600;
}
.ai-seller-select >>> .vs__deselect { fill: #60a5fa; margin-left: 6px; opacity: .8; }
.ai-seller-select >>> .vs__deselect:hover { fill: #1d4ed8; opacity: 1; }
/* dropdown panel */
.ai-seller-select >>> .vs__dropdown-menu {
  border: 1px solid #e2e8f0; border-radius: 12px; box-shadow: 0 10px 30px rgba(16,24,40,.12);
  padding: 6px; margin-top: 6px; max-height: 240px;
}
.ai-seller-select >>> .vs__dropdown-option {
  border-radius: 9px; padding: 7px 10px; color: #334155;
}
.ai-seller-select >>> .vs__dropdown-option--highlight { background: #eff6ff; color: #1e40af; }
.ai-seller-select >>> .vs__dropdown-option--highlight .ai-opt-name { color: #1e40af; }
.ai-seller-select >>> .vs__open-indicator { fill: #94a3b8; }
.ai-seller-select >>> .vs__clear { fill: #cbd5e1; }
.ai-seller-select >>> .vs__no-options { color: #94a3b8; font-size: 13px; padding: 12px; }
/* fade transition when the grid opens */
.ai-fade-enter-active, .ai-fade-leave-active { transition: opacity .25s, transform .25s; }
.ai-fade-enter, .ai-fade-leave-to { opacity: 0; transform: translateY(-6px); }

/* Sticky save bar confined to the content column (not the viewport), so it can't
   overflow/clip like the global fixed .btn-bottom-toolbar did. */
.settings-save-bar {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #ededed;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  z-index: 40;
}

.popup-notif {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 60%;
}

.tag-rail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}

.rail-container {
  overflow: hidden;
  height: 36px;
  padding-top: 6px;
  cursor: pointer;
  scroll-behavior: smooth;
}

.tag {
  background: #e3ebf7;
  border-radius: 8px;
  padding: 3px 8px 4px;
  margin: 5px 4px;
  color: #109d93;
  font-weight: 500;
  user-select: none;
  border: 1px solid #e3ebf7;
  transition-duration: 0.25s;
  white-space: nowrap;
  border: 2px dashed #067d75;
}

.tag:first-child {
  margin-left: 16px;
}

.tag:last-child {
  margin-right: 16px;
}

.tag:hover {
  background: #dce4f0;
}

.tag:active {
  background: #e3ebf7;
}

.tag-selected {
  background: #3b71ca;
  color: #fff;
  border: 1px solid #3b71ca;
}

.tag-selected:hover {
  background: #3265b9;
  color: #fff;
}

.tag-selected:active {
  background: #3b71ca;
  color: #fff;
}

[class*="toggle__dot-"] {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked~[class*="toggle__dot-"] {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

.flex-imp {
  display: flex !important;
}

input:checked~.toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.hori-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vs-chip--close {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  margin-left: 8px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  transition: all 0.3s ease;
}

.vs-chip--close:after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.max-height-200 {
  max-height: 200px;
}

.max-height-300 {
  max-height: 300px;
}

.tag_cities {
  max-height: 19vh;
  overflow-y: scroll;
}

/* total width */
.tag_cities::-webkit-scrollbar {
  width: 7px
}

/* scrollbar itself */
.tag_cities::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
}

.dtag_cities::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4
}

/* set button(top and bottom of the scrollbar) */
.dropdown_warhouse::-webkit-scrollbar-button {
  display: none
}
</style>